import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton as MuiIconButton, Tooltip, iconButtonClasses } from '@mui/material';
import { forwardRef } from 'react';
const IconButton = forwardRef(({ tooltip, ...props }, ref) => {
    if (!tooltip)
        return _jsx(MuiIconButton, { ref: ref, ...props });
    return (_jsx(Tooltip, { ...tooltip, children: _jsx(MuiIconButton, { ref: ref, ...props }) }));
});
export { IconButton, iconButtonClasses };
